import {
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';

import { AllowedOrderByValues, type OrderBy } from '@common-lib';

import { SearchFilterModel } from '../common';

export class SearchStampCardSortbyModel {
  @IsEnum(['ID', 'CREATED_AT'])
  declare field: 'ID' | 'CREATED_AT';

  @IsEnum(AllowedOrderByValues)
  declare order: OrderBy;
}

export type ValidityStatus = 'TERMINATED' | 'INACTIVE' | 'ACTIVE';

export class SearchStampCardFilterModel extends SearchFilterModel {
  @IsOptional()
  @IsString()
  declare validityStatus: ValidityStatus | undefined;
}

export class SearchStampCardModel {
  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare filter: SearchStampCardFilterModel | undefined;

  @IsOptional()
  @IsNumber()
  declare pageSize: number | undefined;

  @IsOptional()
  @IsString()
  declare pageToken: string | undefined;

  @IsOptional()
  @IsObject()
  @ValidateNested()
  declare sortBy: SearchStampCardSortbyModel;
}
